<template>
  <transition name="modal">
    <div class="modal" v-if="activeModal==='search'">
      <div class="modal__dialog">
        <i class="modal__close close" @click="closeModal" />
        <div class="modal__content">
          <div class="modal__top-search top-search" :class="{'is-focused':searchFocused,'is-active':searchActive}">
            <form @submit.prevent="routeSearch" class="top-search__search">
              <input type="text" class="top-search__input" @focus="focusSearch"
                @blur="blurSearch" v-model="searchInput" ref="searchInput">
              <button class="top-search__icon">
                <search-icon-mobile class="top-search__svg" />
              </button>
            </form>
            <div class="top-search__list" v-if="listOpen" ref="listScroller">
              <router-link class="top-search__item" :to="beverage.path" v-for="(beverage, b) in filteredBeverages"
                :key="b" @click.native="resetSearch" v-text="beverage.title"
              />
            </div>
          </div>
        </div>
      </div>
      <i class="modal__backdrop" @click="closeModal" />
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import latinize from 'latinize'

import SearchIconMobile from '@/elements/SearchIconMobile'

// import ifDefined from '@/tools/ifDefined'

export default {
  components: {
    SearchIconMobile
  },
  computed: {
    ...mapGetters(['beverages', 'allBeverages', 'activeModal'])
  },
  data() {
    return {
      filteredBeverages: {},
      listOpen: false,
      searchActive: false,
      searchFocused: false,
      listScroller: null,
      searchInput: ''
    }
  },
  methods: {
    ...mapActions(['openModal', 'closeModal']),
    routeSearch() {
      if (this.searchInput.length) {
        this.listOpen = false
        this.$router.push({
          path: '/search/' + latinize(this.searchInput).toLowerCase()
        })
        this.closeModal()
      }
    },
    focusSearch() {
      this.searchFocused = true
      this.searchActive = true
      this.listOpen =
        Boolean(this.searchInput.length) &&
        this.searchActive &&
        this.filteredBeverages.length
    },
    blurSearch() {
      this.searchFocused = false
    },
    resetSearch() {
      this.searchActive = false
      this.searchInput = ''
      this.listOpen = false
    }
  },
  // updated() {
  //   this.$nextTick(() => {
  //     if (ifDefined(this.$refs['searchInput'])) {
  //       this.$refs['searchInput'].focus()
  //     }
  //   })
  // },
  name: 'SearchModal',
  watch: {
    searchInput(input) {
      if (this.allBeverages.length) {
        this.filteredBeverages = this.allBeverages.filter(item => {
          return latinize(item['search'])
            .toLowerCase()
            .includes(latinize(input).toLowerCase())
        })
      }
      this.listOpen =
        Boolean(input.length) &&
        this.searchActive &&
        this.filteredBeverages.length
    },
    $route(to) {
      if (to.name !== 'SearchResults') {
        this.searchActive = false
        this.searchFocused = false
        this.searchInput = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/SearchModal.vue